import * as React from 'react';

import { CustomDialog } from 'components/Dialogs/CustomDialog';
import { documentsToNameList } from 'functions/documents/documentUtils';
import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';
import { AnimatedLoaderModal } from 'components/Loaders/AnimatedLoader';

import styles from './styles.module.scss';

type InputProps = {
  isLoading: boolean;
  isSuccess: boolean;
  open: boolean;
  setOpen: (open: boolean) => void;
  documentType: string;
  candidateFullName: string;
  onPurge: () => void;
};

export const ConfirmPurgeDocumentForeverDialog = ({
  isLoading = false,
  isSuccess = false,
  open = false,
  setOpen,
  documentType,
  candidateFullName,
  onPurge,
}: InputProps) => {
  return (
    <CustomDialog open={open} setOpen={setOpen} title="Purge Document Forever?">
      {isLoading ? (
        <AnimatedLoaderModal
          isLoading={!isSuccess}
          classNameWrapper={styles.loaderWrapper}
        />
      ) : (
        <div className={styles.root}>
          <div className={styles.description}>
            Are you sure you want to delete the{' '}
            <b>{documentsToNameList([documentType])} </b> of{' '}
            <b>{candidateFullName}</b>? This action is not reversible.
          </div>
          <div className={styles.note}>
            Note: All documents are automatically purged 60 days after
            uploading.
          </div>
          <div className={styles.actions}>
            <ButtonWithArrowIcon onClick={onPurge}>Confirm</ButtonWithArrowIcon>
          </div>
        </div>
      )}
    </CustomDialog>
  );
};
